(function () {
  'use strict';

  if (window.__aeenSkeletonLoader) return;
  window.__aeenSkeletonLoader = true;

  var imageSelector = '[data-aeen-card-image], .aeen-card-image, .product-image img, .aeen-search-collection__media img';
  var mediaSelector = '.aeen-c-media, .product-image, .aeen-search-collection__media';
  var loaderSelector = '[data-aeen-loader], #recently_wrap';
  var gridSelector = '[data-aeen-product-grid], .aeen-shop-filtered-grid, .aeen-shop-collection__grid, .template-collection .nt_products_holder, .template-search .nt_products_holder';
  var filterSelector = '.nt_ajaxsortby a, #shopify-section-nt_filter a[href*="filter."], #shopify-section-nt_filter2 a[href*="filter."], [data-aeen-filter-value], [data-aeen-sort-value]';
  var frame = 0;
  var remoteObserver = null;

  function nodes(root, selector) {
    var result = [];
    if (!root) return result;
    if (root.nodeType === 1 && root.matches(selector)) result.push(root);
    if (root.querySelectorAll) result = result.concat(Array.prototype.slice.call(root.querySelectorAll(selector)));
    return result;
  }

  function mediaFor(image) {
    return image.closest(mediaSelector);
  }

  function setMediaState(media, state) {
    if (!media) return;
    media.classList.remove('is-aeen-loading', 'is-aeen-loaded', 'is-aeen-error');
    media.classList.add('is-aeen-' + state);
    var card = media.closest('[data-aeen-product-card], .aeen-c-card');
    if (card) {
      card.classList.toggle('is-aeen-card-loading', state === 'loading');
      card.classList.toggle('is-aeen-card-loaded', state === 'loaded');
    }
  }

  function watchImage(image) {
    if (!image || image.dataset.aeenSkeletonBound === '1') return;
    image.dataset.aeenSkeletonBound = '1';
    var media = mediaFor(image);
    var lazySource = image.dataset.src || image.dataset.srcset;

    function loaded() {
      if (image.naturalWidth > 0) setMediaState(media, 'loaded');
      else setMediaState(media, 'error');
    }

    function failed() {
      setMediaState(media, 'error');
    }

    if (lazySource && !image.classList.contains('lazyloaded')) {
      setMediaState(media, 'loading');
      image.addEventListener('lazyloaded', loaded, { once: true });
      image.addEventListener('error', failed, { once: true });
      return;
    }

    if (image.complete) {
      loaded();
      return;
    }

    setMediaState(media, 'loading');
    image.addEventListener('load', loaded, { once: true });
    image.addEventListener('error', failed, { once: true });
  }

  function watchBackgroundMedia(media) {
    if (!media || media.dataset.aeenBackgroundBound === '1' || media.querySelector('img')) return;
    var lazy = media.querySelector('.lazyload, .lazyloading, [data-bgset], [data-bg], [data-src]');
    if (!lazy) return;
    media.dataset.aeenBackgroundBound = '1';

    function loaded() {
      setMediaState(media, 'loaded');
    }

    function failed() {
      setMediaState(media, 'error');
    }

    if (lazy.classList.contains('lazyloaded')) {
      loaded();
      return;
    }

    setMediaState(media, 'loading');
    lazy.addEventListener('lazyloaded', loaded, { once: true });
    lazy.addEventListener('load', loaded, { once: true });
    lazy.addEventListener('error', failed, { once: true });
  }

  function scanImages(root) {
    nodes(root, imageSelector).forEach(watchImage);
    nodes(root, mediaSelector).forEach(watchBackgroundMedia);
  }

  function finishLoader(loader) {
    if (!loader) return;
    loader.setAttribute('aria-busy', 'false');
    loader.classList.remove('is-loading');
    loader.classList.add('is-loaded');
    nodes(loader, '[data-aeen-skeleton]').forEach(function (skeleton) {
      skeleton.hidden = true;
    });
  }

  function inspectLoader(loader) {
    if (!loader) return;
    var busy = loader.getAttribute('aria-busy') === 'true';
    var hasCards = !!loader.querySelector('.aeen-c-card, [data-aeen-product-card]');
    var hasSkeleton = !!loader.querySelector('[data-aeen-skeleton]');

    if (!busy || hasCards || !hasSkeleton) {
      finishLoader(loader);
      return;
    }

    loader.classList.add('is-loading');
    loader.classList.remove('is-loaded');
    observeRemoteLoader(loader);
    if (loader.dataset.aeenLoaderTimer !== '1') {
      loader.dataset.aeenLoaderTimer = '1';
      window.setTimeout(function () {
        if (document.documentElement.contains(loader) && loader.getAttribute('aria-busy') === 'true') {
          finishLoader(loader);
          loader.classList.add('is-aeen-timeout');
        }
      }, 20000);
    }
  }

  function recommendationUrl(loader) {
    var url = new URL(loader.dataset.baseurl, window.location.origin);
    if (loader.dataset.type === '3') {
      var sectionRoot = loader.closest('[id^="shopify-section-"]');
      var sectionId = sectionRoot ? sectionRoot.id.replace('shopify-section-', '') : 'product-recommendations';
      url.searchParams.set('section_id', sectionId);
      url.searchParams.set('product_id', loader.dataset.id || '');
      url.searchParams.set('limit', loader.dataset.limit || '4');
      url.searchParams.set('intent', 'related');
    }
    return url.toString();
  }

  function loadRemoteSection(loader) {
    if (!loader || loader.dataset.aeenRemoteRequested === '1') return;
    loader.dataset.aeenRemoteRequested = '1';

    fetch(recommendationUrl(loader), {
      headers: { Accept: 'text/html', 'X-Requested-With': 'XMLHttpRequest' }
    }).then(function (response) {
      if (!response.ok) throw new Error('Product section request failed');
      return response.text();
    }).then(function (html) {
      var documentFragment = new DOMParser().parseFromString(html, 'text/html');
      var replacement = documentFragment.querySelector('[data-aeen-products-ready], [data-aeen-loader="recommendations"][aria-busy="false"]');
      if (!replacement) {
        finishLoader(loader);
        loader.classList.add('is-aeen-empty');
        return;
      }
      var imported = document.importNode(replacement, true);
      loader.replaceWith(imported);
      schedule(imported);
      document.dispatchEvent(new CustomEvent('aeen:products:rendered'));
    }).catch(function () {
      finishLoader(loader);
      loader.classList.add('is-aeen-error');
    });
  }

  function observeRemoteLoader(loader) {
    if (!loader.dataset.baseurl || loader.dataset.aeenRemoteObserved === '1') return;
    loader.dataset.aeenRemoteObserved = '1';
    if (!remoteObserver) {
      loadRemoteSection(loader);
      return;
    }
    remoteObserver.observe(loader);
  }

  function scanLoaders(root) {
    nodes(root, loaderSelector).forEach(inspectLoader);
  }

  function initTracks(root) {
    if (typeof window.aeenTrack !== 'function') return;
    nodes(root, '.aeen-cs, [data-aeen-products-ready]').forEach(function (section) {
      if (section.querySelector('[data-track]')) window.aeenTrack(section);
    });
  }

  function skeletonCard() {
    return '<div class="aeen-skeleton-card"><span class="aeen-skeleton-media"></span><span class="aeen-skeleton-line aeen-skeleton-line--title"></span><span class="aeen-skeleton-line"></span><span class="aeen-skeleton-line aeen-skeleton-line--short"></span><span class="aeen-skeleton-action"></span></div>';
  }

  function startGridLoading(grid) {
    if (!grid || grid.classList.contains('is-aeen-grid-loading')) return;
    var skeleton = document.createElement('div');
    skeleton.className = 'aeen-grid-skeleton';
    skeleton.setAttribute('data-aeen-grid-skeleton', '');
    skeleton.setAttribute('aria-hidden', 'true');
    skeleton.innerHTML = skeletonCard() + skeletonCard() + skeletonCard() + skeletonCard();
    grid.classList.add('is-aeen-grid-loading');
    grid.setAttribute('aria-busy', 'true');
    grid.appendChild(skeleton);
    window.setTimeout(function () {
      finishGridLoading(grid);
    }, 15000);
  }

  function finishGridLoading(grid) {
    if (!grid) return;
    grid.classList.remove('is-aeen-grid-loading');
    grid.setAttribute('aria-busy', 'false');
    nodes(grid, '[data-aeen-grid-skeleton]').forEach(function (skeleton) {
      skeleton.remove();
    });
  }

  function productGrid() {
    return document.querySelector(gridSelector);
  }

  function schedule(root) {
    if (frame) window.cancelAnimationFrame(frame);
    frame = window.requestAnimationFrame(function () {
      frame = 0;
      scanImages(root || document);
      scanLoaders(root || document);
      initTracks(root || document);
    });
  }

  function boot() {
    if ('IntersectionObserver' in window) {
      remoteObserver = new IntersectionObserver(function (entries) {
        entries.forEach(function (entry) {
          if (!entry.isIntersecting) return;
          remoteObserver.unobserve(entry.target);
          loadRemoteSection(entry.target);
        });
      }, { rootMargin: '300px 0px' });
    }
    schedule(document);

    var observer = new MutationObserver(function (mutations) {
      var changedGrid = false;
      mutations.forEach(function (mutation) {
        Array.prototype.forEach.call(mutation.addedNodes, function (node) {
          if (node.nodeType !== 1) return;
          schedule(node);
          var grid = node.closest && node.closest(gridSelector);
          if (grid && !node.matches('[data-aeen-grid-skeleton]')) changedGrid = grid;
        });
        var loader = mutation.target.closest && mutation.target.closest(loaderSelector);
        if (loader) inspectLoader(loader);
      });
      if (changedGrid) finishGridLoading(changedGrid);
    });

    observer.observe(document.body, { childList: true, subtree: true });
  }

  document.addEventListener('click', function (event) {
    var control = event.target.closest && event.target.closest(filterSelector);
    if (control) startGridLoading(productGrid());
  }, true);

  document.addEventListener('change', function (event) {
    if (event.target.matches('[name="sort_by"], [name^="filter."]')) startGridLoading(productGrid());
  }, true);

  document.addEventListener('lazyloaded', function (event) {
    var media = event.target.closest && event.target.closest(mediaSelector);
    if (media) setMediaState(media, 'loaded');
  }, true);

  document.addEventListener('aeen:products:rendered', function () {
    schedule(document);
  });
  document.addEventListener('shopify:section:load', function (event) {
    schedule(event.target);
  });
  window.addEventListener('pageshow', function () {
    schedule(document);
  });

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot, { once: true });
  else boot();
})();
